

























































import Vue, { PropOptions } from 'vue';
import dayjs from 'dayjs';
import { Campaign } from '@/models';
import store from '@/store';
import { CampaignViewTableType } from '@/services/CampaignMessageService';

export default Vue.extend({
  props: {
    campaign: Object as PropOptions<Campaign>,
    type: String as PropOptions<CampaignViewTableType>,
    campaignMessages: {
      type: Array,
      default: () => store.state.campaignMessage.campaignMessages,
    },
    loading: {
      type: Boolean,
      default: () => store.state.campaignMessage.loading,
    },
    isMobile: Boolean,
    columns: {
      type: Array,
      default: () => [
        { label: 'Telefone', value: 'destinationId' },
        { value: 'tokens' },
        { label: 'Enviado em', value: 'sentAt' },
        { label: 'Clicado em', value: 'clickedAt' },
        { label: 'Respondida em', value: 'repliedAt' },
        { label: 'Resposta', value: 'repliedTextMessage' },
      ],
    },
    sortBy: String,
    sortDesc: Boolean,
  },
  data() {
    const tokensColumns = this.columns.find((col: any) => col.value === 'tokens') &&
      this.campaign && this.campaign.audienceFileTokenMapping &&
      this.campaign.audienceFileTokenMapping.length &&
      this.campaign.audienceFileTokenMapping.map((item) => (
        { text: item.token, value: item.token, align: 'left', sortable: false }
      )) || [];
    let headers: any[] = [];
    this.columns.forEach((col: any) => {
      if (col.value === 'tokens') {
        headers = [...headers, ...tokensColumns];
      } else {
        headers.push({ text: col.label, value: col.value, align: 'left' });
      }
    });
    const initialOptions = {
      sortDesc: [true],
      sortBy: [this.sortBy],
      itemsPerPage: 10,
      page: 1,
    };
    return {
      tokensColumns,
      headers,
      lastOptions: initialOptions,
      options: { ...initialOptions },
    };
  },
  mounted() {
    const { sortBy, sortDesc, page, itemsPerPage } = this.options as any;
    const filters = {
      campaignId: this.campaign.objectId,
      page,
      pageSize: itemsPerPage,
      orderBy: sortBy[0],
      orderDesc: sortDesc[0],
      type: this.type,
    };

    this.$store.commit('setCampaignMessagesFilters', filters);
    this.$store.dispatch('loadCampaignMessagesByType', filters);

  },
  watch: {
    type(val) {
      const filters = {
        campaignId: this.campaign.objectId,
        page: 1,
        pageSize: 10,
        orderBy: this.sortBy,
        orderDesc: true,
        type: this.type,
      };

      this.$store.commit('setCampaignMessagesFilters', filters);
      this.$store.dispatch('loadCampaignMessagesByType', filters);
    },
    options: {
      handler() {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options as any;
        if (
          sortBy[0] !== this.lastOptions.sortBy[0] ||
          sortDesc[0] !== this.lastOptions.sortDesc[0] ||
          page !== this.lastOptions.page ||
          itemsPerPage !== this.lastOptions.itemsPerPage
        ) {
          const filters = {
            campaignId: this.campaign.objectId,
            page,
            pageSize: itemsPerPage,
            orderBy: sortBy[0],
            orderDesc: sortDesc[0],
            type: this.type,
          };

          this.$store.commit('setCampaignMessagesFilters', filters);
          this.$store.dispatch('loadCampaignMessagesByType', filters);
          this.lastOptions = { sortBy, sortDesc, page, itemsPerPage };
        }
      },
      deep: true,
    },
  },
  methods: {
    getTokenName(col: any) {
      return `item.${col.value}`;
    },
    formatDate(date: {iso: string}) {
      if (date) {
        return dayjs(date.iso).format('DD MMM YYYY HH:mm');
      }
      return '-';
    },
    getTokenValue(tokens: any, col: any) {
      const found = tokens.find((t: any) => t.name === col.value );
      return tokens && found && found.value;
    },
  },
});
